<template>
  <ContentTemplate class="row-margin" title="Upgrade" :container-size-small="false">
    <div class="row">
      <div class="col-12 col-package-headline">
        <h1>Evaluate Our Pricing Options</h1>
        <p>Get a 14-day free trial with yearly subscription.</p>
      </div>
    </div>

    <div class="row col-package-actions">
      <div class="col-package-select">
        <div class="package-selectable" :class="{ active: !isSubscriptionTypeYearly }"
             @click="setSubscriptionTypeYearly(false)">
          Monthly
        </div>
        <div class="package-selectable" :class="{ active: isSubscriptionTypeYearly }"
             @click="setSubscriptionTypeYearly(true)">
          Yearly (Save 28%)
        </div>
      </div>
      <div class="col-package-info">
        <p>How many users are on the team?</p>

        <div class="package-editors">

          <div class="key" @click="decreaseEditor">
            <LucideIcon icon="Minus"/>
          </div>

          <input class="form-check-input" type="number" v-model="editorCount"
                 @blur="validateEditorCount">

          <div class="key" @click="increaseEditor">
            <LucideIcon icon="Plus"/>
          </div>

        </div>
      </div>
    </div>

    <div class="row" style="display: flex; justify-content: center;">
      <div class="col-4 ">
        <div class="col-upgrade-box" :style="[currentWsPlan === sProduct.key ? '' : '']">
          <div class="upgrade-box-headline">
            <h2>{{ sProduct.name }}</h2>
            <p class="plan-subtitle">Idea Owner</p>
            <p class="plan-summary">For early stage teams developing<br/> first ideas</p>
          </div>
          <div class="upgrade-box-price">
            <h1>$0</h1>
            <p class="user">per user / year</p>
            <p class="total">always free for <span>3 users</span></p>
            <p class="tag">
              <span class="tag--default tag--neutral">
                Free for ever
              </span>
            </p>

          </div>
          <div class="upgrade-button">
            <ButtonElement
                v-if="currentWsPlan === pProduct.key"
                class="btn--ms btn--neutral btn--lg btn--full"
                @click="changeToPackage(sProduct)">
              Downgrade to Free
            </ButtonElement>

            <ButtonElement
                v-else
                class="btn--ms btn--accent btn--lg btn--full"
                :is-disable="currentWsPlan === sProduct.key"
                @click="changeToPackage(sProduct)">
              Selected
            </ButtonElement>

            <hr/>
          </div>
          <div class="upgrade-package">
            <ul>
              <li>
                <ul class="nested-list one">
                  <li class="subheadline">Core Features</li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        AI-Powered Requirements Generation
                      </div>
                      <div class="text">
                        Automatically generate, feature, user story, acceptance criteria and more
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        UI Screen Management
                      </div>
                      <div class="text">
                        Organize and structure product UI screens and align with feature
                        documentation.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        Import from
                        <img src="@/assets/integrations/jira.svg" alt="Jira Cloud" title="Jira Cloud"
                             class="jira"/>
                        Jira &
                        <img src="@/assets/integrations/figma.svg" alt="Figma" title="Figma"
                             class="figma"/>
                        Figma
                      </div>
                      <div class="text">
                        Bring in issues and UI designs for seamless requirement mapping.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        PRD Export for No-Code Platforms
                      </div>
                      <div class="text">
                        Generate structured documents compatible with no-code platforms.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        Shareable Public Link
                      </div>
                      <div class="text">
                        Publish and share PRDs with stakeholders via public access.
                      </div>
                    </div>
                  </li>
                </ul>
              </li>

              <li>
                <ul class="in-pipeline">
                  <li class="subheadline">
                    <LucideIcon icon="Hourglass"/>
                    In the Pipeline
                  </li>
                  <li>
                    <div class="summary">
                      <div class="title">
                        AI UI Screen Planning
                      </div>
                      <div class="text">
                        Generates feature-based UI design placeholder.
                      </div>
                    </div>
                  </li>
                </ul>
              </li>

              <li>
                <ul class="nested-list two">
                  <li class="subheadline">Workspace Credits</li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        3 Projects
                      </div>
                      <div class="text">
                        Create and manage up to 3 separate projects.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        3 Members
                      </div>
                      <div class="text">
                        Collaborate with up to 3 team members.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        50 x UI Screens
                      </div>
                      <div class="text">
                        Manage up to 50 screens across all projects.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        AI Credits: 20 / day
                      </div>
                      <div class="text">
                        Approx 600 AI Generation monthly per workspace.
                      </div>
                    </div>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="col-upgrade-box col-pro"
             :style="[currentWsPlan === pProduct.key ? '' : '']">

          <div class="upgrade-box-headline">
            <h2>{{ pProduct.name }}
              <UpgradeElement size="sm"/>
            </h2>
            <p class="plan-subtitle">Product Owner</p>
            <p class="plan-summary">For product teams developing<br/> digital products</p>
          </div>

          <div class="upgrade-box-price">
            <h1>${{ isSubscriptionTypeYearly ? pProduct.yearlyPrice : pProduct.monthlyPrice }}</h1>
            <p class="user">per user / {{ isSubscriptionTypeYearly ? 'yearly' : 'monthly' }}</p>
            <p class="total"><span>${{ pProductTotal }}</span>
              {{ isSubscriptionTypeYearly ? 'yearly' : 'monthly' }} total for <span>{{
                  editorCount
                }} {{ editorCount === 1 ? 'user' : 'users' }}</span></p>
            <p class="tag">
              <span :style="{ visibility: isSubscriptionTypeYearly ? 'visible' : 'hidden' }"
                    class="tag--default tag--blue">14-day free trial</span>

              <span :style="{ visibility: isSubscriptionTypeYearly ? 'visible' : 'hidden' }"
                    class="tag--default tag--accent">Onboarding Call</span>
            </p>
          </div>

          <div class="upgrade-button">
            <ButtonElement v-if="currentWsPlan === pProduct.key"
                           class="btn--ms btn--accent btn--lg btn--full"
                           @click="changeToPackage(pProduct)"
                           :is-disable="!isCurrentProductChanged">
              {{ isCurrentProductChanged ? 'Upgrade' : 'Selected' }}
            </ButtonElement>
            <ButtonElement v-if="currentWsPlan !== pProduct.key"
                           class="btn--ms btn--accent btn--lg btn--full"
                           @click="changeToPackage(pProduct)">
              <LucideIcon icon="ChevronsUp"/>
              Upgrade to Pro
            </ButtonElement>
            <hr/>
          </div>
          <div class="upgrade-package">
            <ul>
              <li>
                <ul class="nested-list one">
                  <li class="subheadline">Includes everything in Starter, plus:</li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        AI Pro: High-Level LLM
                      </div>
                      <div class="text">
                        Uses higher level Language Models to generate more accurate results.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        AI Pro: Advanced Requirement Methods
                      </div>
                      <div class="text">
                        More methods for Analysis, User Story and Acceptance Criteria generation.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        <img src="@/assets/integrations/jira.svg" alt="Jira Cloud" title="Jira Cloud"
                             class="jira"/> Jira Two-Way Sync
                      </div>
                      <div class="text">
                        Keep requirements and Jira tickets synchronized in both directions.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        Reusable Libraries (3x)
                      </div>
                      <div class="text">
                        Store and reuse requirements, across projects.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        Private Public Link
                      </div>
                      <div class="text">
                        Publish and share PRDs with stakeholders via private access.
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
              <li>
                <ul class="in-pipeline">
                  <li class="subheadline">
                    <LucideIcon icon="Hourglass"/>
                    In the Pipeline
                  </li>
                  <li>
                    <div class="summary">
                      <div class="title">
                        AI Reverse Engineering
                      </div>
                      <div class="text">
                        Upload any screen and let AI generate the related features.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="summary">
                      <div class="title">
                        AI Document Analyser
                      </div>
                      <div class="text">
                        Upload any product related document and get feature and user story
                        suggestions.
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
              <li>
                <ul class="nested-list two">
                  <li class="subheadline">Workspace Credits</li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        Unlimited Projects
                      </div>
                      <div class="text">
                        Create and manage as many projects as needed, no project limit.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        5 x Project Container
                      </div>
                      <div class="text">
                        Organize up to 5 project containers for structured product planning.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        Unlimited Team Members
                      </div>
                      <div class="text">
                        Invite as many collaborators as needed for seamless team collaboration.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        200 x UI Screens / Workspace
                      </div>
                      <div class="text">
                        Each new team member receives an additional 200 UI Screens.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        AI Credits: 1,000 x AI Credits / Workspace
                      </div>
                      <div class="text">
                        Each new team member receives an additional 1,000 AI Credits.
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-4">

        <div class="col-upgrade-box col-bus" :style="[currentWsPlan === bProduct.key ? '' : '']">

          <div class="upgrade-box-headline">
            <h2>{{ bProduct.name }}
              <UpgradeElement size="sm" package="bus"/>
            </h2>
            <p class="plan-subtitle">Business Owner</p>
            <p class="plan-summary">For companies developing<br/>digital products for clients</p>
          </div>

          <div class="upgrade-box-price">
            <h1>Contact Sale</h1>

            <p class="user" style="min-height: 107px">Get early access to Agency Super Powers. Best
              for Software Houses and Agencies</p>

          </div>

          <div class="upgrade-button">
            <ButtonElement v-if="currentWsPlan !== bProduct.key"
                           class="btn--ms btn--accent btn--lg btn--full"
                           @click="notifyMeForBusiness"
                           :is-disable="notifyRequested">
              <LucideIcon icon="ChevronsRight"/>
              Request Now
            </ButtonElement>
            <hr/>
          </div>
          <div class="upgrade-package">
            <ul>

              <li>
                <ul class="nested-list one">
                  <li class="subheadline">Includes everything in Pro, plus:</li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        AI Estimation Assistant
                      </div>
                      <div class="text">
                        Generates project estimation based on features or ui screens.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        AI Proposal Generation
                      </div>
                      <div class="text">
                        Generate Quotation Website with digital Sign.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        Unlimited Reusable Libraries
                      </div>
                      <div class="text">
                        Scale reusable content without limits.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        Customizable Branding
                      </div>
                      <div class="text">
                        Apply logos, colors, and branding to shared PRDs to clients.
                      </div>
                    </div>
                  </li>
                </ul>
              </li>

              <li>
                <ul class="in-pipeline">
                  <li class="subheadline">
                    <LucideIcon icon="Hourglass"/>
                    In the Pipeline
                  </li>
                  <li>
                    <div class="summary">
                      <div class="title">
                        Platform specific AI Knowledge Base
                      </div>
                      <div class="text">
                        For Service Provider with Focus on special Tools or Technologies.
                      </div>
                    </div>
                  </li>
                </ul>
              </li>

              <li>
                <ul class="nested-list two">
                  <li class="subheadline">Workspace Credits</li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        Unlimited Projects
                      </div>
                      <div class="text">
                        Create and manage as many projects as needed, no project limit.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        Unlimited Project Container
                      </div>
                      <div class="text">
                        Organize unlimited product lines or business units with flexible project
                        containers.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        UI Screens: Related to Team Size
                      </div>
                      <div class="text">
                        UI screen limits scale based on team size.
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <LucideIcon icon="Check"/>
                    </div>
                    <div class="summary">
                      <div class="title">
                        AI Credits: Related to Team Size
                      </div>
                      <div class="text">
                        AI usage scales with the number of team members, ideal for larger teams.
                      </div>
                    </div>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </ContentTemplate>
  <CancelSubscriptionPopup
      :show-popup="showCancelSubscriptionPopup"
      :current-product-id="currentProduct.productId"
      :current-product-name="currentProduct.name"
      @close="showCancelSubscriptionPopup = false"
  ></CancelSubscriptionPopup>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {ButtonElement, ContentTemplate} from '@shared/components';
import {useProductStore} from "@domains/settings/stores/product.store";
import {ProductNs} from "@shared/types";
import {useWsMemberStore} from "@domains/settings/stores/workspace-member.store";
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useUserStore} from "@shared/stores/user.store";
import {config} from "@/config";
import {useGeneralStore} from "@shared/stores/general.store";
import CryptoJS from 'crypto-js'
import UpgradeElement from "@shared/components/elements/labels/upgrade.element.vue";
import {getLocalStorage, setLocalStorage} from "@shared/helpers";
import CancelSubscriptionPopup from "@domains/settings/views/cancel-subscription.popup.vue";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'UpgradeView',
  components: {
    CancelSubscriptionPopup,
    UpgradeElement,
    ContentTemplate,
    ButtonElement
  },
  setup() {
    // initialize the store
    const userStore = useUserStore()
    const wsMemberStore = useWsMemberStore()
    const workspaceStore = useWorkspaceStore()
    const productStore = useProductStore()
    const generalStore = useGeneralStore()
    return {workspaceStore, wsMemberStore, productStore, userStore, generalStore}
  },
  mounted() {
    const productList = this.productStore.productList;
    const resultMap: Map<ProductNs.ProductType, any> = new Map();
    productList.forEach((p) => {
      let dto = resultMap.get(p.key);
      if (!dto) {
        dto = {key: p.key, name: p.name};
        resultMap.set(p.key, dto);
      }

      if (p.type === 'MONTHLY') {
        dto.monthlyProductId = p.productId;
        dto.monthlyPrice = p.price;
      } else {
        dto.yearlyProductId = p.productId;
        dto.yearlyPrice = p.price;
      }
    });

    this.sProduct = resultMap.get(ProductNs.ProductType.FREE);
    this.pProduct = resultMap.get(ProductNs.ProductType.PROFESSIONAL);
    this.bProduct = resultMap.get(ProductNs.ProductType.BUSINESS);

    this.currentWsPlan = this.currentProduct.key;
    this.isSubscriptionTypeYearly = true;
    this.editorCount = this.wsMemberStore.getWorkspaceMemberCount;
    this.notifyRequested = getLocalStorage(`buNotifyRequested.${this.workspaceStore.getSelectedWorkspaceId}`);
  },
  computed: {
    pProductTotal(): string {
      return (Math.round((this.isSubscriptionTypeYearly ? (this.pProduct.yearlyPrice * 12) : this.pProduct.monthlyPrice) * this.editorCount * 100) / 100).toFixed(2);
    },
    bProductTotal(): string {
      return (Math.round((this.isSubscriptionTypeYearly ? (this.bProduct.yearlyPrice * 12) : this.bProduct.monthlyPrice) * this.editorCount * 100) / 100).toFixed(2);
    },
    currentProduct(): ProductNs.Product {
      return this.productStore.currentProduct;
    }
  },
  data() {
    return {
      currentWsPlan: ProductNs.ProductType.FREE as ProductNs.ProductType,
      isSubscriptionTypeYearly: true,
      isCurrentProductChanged: false,
      editorCount: 1,
      sProduct: {} as any,
      pProduct: {} as any,
      bProduct: {} as any,
      showCancelSubscriptionPopup: false,
      cancellationReason: '',
      cancellationReasonText: '',
      notifyRequested: false
    }
  },
  methods: {
    notifyMeForBusiness() {
      this.workspaceStore.sendUpgradeRequest({
        workspaceId: this.workspaceStore.getSelectedWorkspaceId,
        projectId: ''
      }).then(() => {
        this.notifyRequested = true;
        setLocalStorage(`buNotifyRequested.${this.workspaceStore.getSelectedWorkspaceId}`, true)

        // Show toaster message
        toast.success('Request completed.', {description: 'A notification will be sent once the upgrade becomes available.'});
      })
    },
    showEditorCountError() {
      toast.warning(`The workspace has ${this.wsMemberStore.getWorkspaceMemberCount} members.`, {
        description: 'To purchase a license with fewer seats, remove members from the workspace.',
      });
    },
    increaseEditor() {
      this.editorCount++;
      this.checkCurrentPlanIsChanged();
    },
    decreaseEditor() {
      if (this.editorCount > 1) {
        if (this.editorCount === this.wsMemberStore.getWorkspaceMemberCount) {
          this.showEditorCountError();
        } else {
          this.editorCount--;
        }
      }
      this.checkCurrentPlanIsChanged();
    },
    setSubscriptionTypeYearly(value: boolean) {
      this.isSubscriptionTypeYearly = value;
      this.checkCurrentPlanIsChanged();
    },
    checkCurrentPlanIsChanged() {
      if ((this.currentProduct.type === 'MONTHLY' && this.isSubscriptionTypeYearly) ||
          (this.currentProduct.type === 'YEARLY' && !this.isSubscriptionTypeYearly) ||
          (this.currentProduct.quantity !== this.editorCount)
      ) {
        this.isCurrentProductChanged = true;
      } else {
        this.isCurrentProductChanged = false;
      }
    },
    upgradeSubscription(product: any) {
      const currentUser = this.userStore.getUserInfo;
      const workspace = this.workspaceStore.getSelectedWorkspace;
      const productId = this.isSubscriptionTypeYearly ? product.yearlyProductId : product.monthlyProductId;

      const key = CryptoJS.enc.Utf8.parse('xf65iTBi9iS04Mk6?9O8QTTpVB$@JzBQ')
      const iv = CryptoJS.enc.Utf8.parse('DeVT4UXf1LG!?Q0A')

      let paymentUrlData = config("APP_PAYMENT_LINK_DATA") as string;
      paymentUrlData = paymentUrlData.replace("${pId}", productId);
      paymentUrlData = paymentUrlData.replace("${ec}", String(this.editorCount));
      paymentUrlData = paymentUrlData.replace("${fn}", currentUser.firstName);
      paymentUrlData = paymentUrlData.replace("${ln}", currentUser.lastName);
      paymentUrlData = paymentUrlData.replace("${un}", currentUser.userName);
      paymentUrlData = paymentUrlData.replace("${wsId}", workspace.wsId);
      paymentUrlData = paymentUrlData.replace("${dId}", String(workspace.dealsId));

      // Encrypt the data
      const encrypted = CryptoJS.AES.encrypt(paymentUrlData, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).ciphertext

      // base64 and URL encode
      const dataFinal = encrypted.toString(CryptoJS.enc.Base64)
      let paymentUrl = config("APP_PAYMENT_LINK") as string;
      paymentUrl = paymentUrl.replace("${data}", dataFinal);

      window.location.replace(paymentUrl);
    },
    changeToPackage(product: ProductNs.Product) {
      // User cancel its subscription and select FREE Plan
      if (this.currentWsPlan !== ProductNs.ProductType.FREE && product.key === ProductNs.ProductType.FREE) {
        this.showCancelSubscriptionPopup = true;
      } else if ((this.currentWsPlan === ProductNs.ProductType.FREE && product.key !== ProductNs.ProductType.FREE) ||
          (this.currentWsPlan === ProductNs.ProductType.PROFESSIONAL && product.key === ProductNs.ProductType.BUSINESS)) {
        // User upgrade its subscription to higher package
        this.upgradeSubscription(product)
      } else {
        if (this.isCurrentProductChanged) {
          const payload = {
            workspaceId: this.workspaceStore.getSelectedWorkspaceId,
            productId: this.currentProduct.productId,
            quantity: this.editorCount
          } as ProductNs.UpdateProductRequest;

          if ((this.currentProduct.type === 'MONTHLY' && this.isSubscriptionTypeYearly) ||
              (this.currentProduct.type === 'YEARLY' && !this.isSubscriptionTypeYearly)
          ) {
            this.productStore.changeProduct(payload).then(() => {
              
              toast.success('Subscription updated');
            })
          } else if (this.currentProduct.quantity !== this.editorCount) {
            this.productStore.changeQuantity(payload).then(() => {
              
              toast.success('Subscription updated');
            })
          }
        }
      }
    },
    validateEditorCount() {
      if (this.editorCount < this.wsMemberStore.getWorkspaceMemberCount) {
        this.showEditorCountError();
        this.editorCount = this.wsMemberStore.getWorkspaceMemberCount;
      }
    }
  }
});

</script>
<style lang="scss" scoped>
.modal-dialog {
  .cancellation-reason {
    margin: var(--space-0);
    padding: var(--space-0);
    list-style-type: none;
    display: flex;
    flex-direction: column;
    gap: var(--space-8);
  }

  .modal-footer {
    padding: var(--space-32);
  }
}

.row-margin {
  margin-bottom: var(--space-68);
}

.col-package-headline {
  text-align: center;

  h1 {
    font-weight: 600;
    font-size: var(--fs-32);
    margin-bottom: var(--space-8);
  }

  p {
    color: var(--text-neutral);
    margin: var(--space-0) var(--space-0) var(--space-32);
    font-size: var(--fs-14);
  }
}

.col-package-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: var(--space-32);
  margin-bottom: var(--space-48);

  .col-package-select {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 360px;
    background-color: var(--button-tab-bg);
    border-bottom: 2px solid var(--button-tab-border);
    color: var(--text-neutral-dark);
    padding: var(--space-0);
    position: relative;
    z-index: 1;

    .package-selectable {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--text-neutral-light);
      cursor: pointer;
      font-weight: 500;;
      padding: var(--space-8);
      gap: var(--space-8);

      &:hover {
        color: var(--text-dark);
      }

      &.active {
        background-color: var(--button-tab-bg);
        border: 0;
        border-bottom: 2px solid var(--button-tab-border-hover) !important;
        color: var(--button-dark-text);
        margin-bottom: var(--space-negative-2) !important;
      }
    }
  }

  .col-package-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: auto;
    border-radius: $br-md;
    position: relative;
    z-index: 1;
    padding: var(--space-0) var(--space-16);
    gap: var(--space-16);

    p {
      color: var(--text-dark);
      font-size: var(--fs-14);
      margin-bottom: var(--space-0);
      font-weight: 500;
    }

    .package-editors {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      position: relative;

      .form-check-input {
        width: 80px;
        height: 35px;
        background-color: var(--form-bg);
        border: 1px solid var(--form-border);
        color: var(--text-dark);
        border-radius: $br-sm;
        text-align: center;
        font-weight: 600;
        font-size: var(--fs-20);
        margin: var(--space-0);

        &:hover {
          background-color: var(--form-bg-hover);
          border: 1px solid var(--form-border-hover);
          box-shadow: var(--form-shadow-outline) !important;
        }

        &:focus,
        &:active,
        &:has(textarea:focus) {
          background-color: var(--form-bg-focus);
          border: 1px solid var(--form-border-focus);
          box-shadow: var(--form-shadow-outline) !important;
        }

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: var(--space-0);
        }
      }

      .key {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: $br-circle;
        background-color: var(--button-accent-bg);
        border: 1px solid var(--button-accent-border);
        color: var(--button-light-text);
        cursor: pointer;

        &:hover {
          background-color: var(--button-accent-bg-hover);
          border: 1px solid var(--button-accent-border) !important;
          color: var(--button-light-text);
        }

        &:focus,
        &:active {
          background-color: var(--button-accent-bg-hover);
          border: 1px solid var(--button-accent-border) !important;
          color: var(--button-light-text);;
          box-shadow: var(--shadow-outline) !important;
        }
      }

      .info-key {
        width: 24px;
        height: 24px;
        background-color: var(--light-100);
        color: var(--text-accent);
        border: 1px solid var(--border-accent-dark);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: $br-circle;
        font-size: var(--fs-12);

        &:hover {
          background-color: var(--accent-10);
        }
      }
    }
  }
}

.col-upgrade-box {
  background-color: var(--card-bg);
  border: 1px solid var(--border-neutral);
  border-radius: $br-lg;
  width: 100%;
  overflow: hidden;

  &:hover {
    background-color: var(--light-100);
    box-shadow: var(--shadow-lg);
  }

  &.col-pro {
    border: 1px solid var(--border-orange-dark);
    box-shadow: var(--card-shadow-active);

    .upgrade-box-headline {
      background: var(--orange-linear);
      border-bottom: 1px solid var(--border-neutral);

      h2 {
        color: var(--text-dark);
      }
    }
  }

  &.col-bus {
    border: 1px solid var(--border-teal-dark);

    .upgrade-box-headline {
      background: var(--teal-linear);
      border-bottom: 1px solid var(--border-neutral);

      h2 {
        color: var(--text-dark);
      }
    }

    .upgrade-box-price {
      h1 {
        display: flex;
        align-items: center;
        min-height: 57px;
        font-size: var(--fs-28);
      }
    }
  }

  .upgrade-box-headline {
    display: flex;
    justify-content: flex-start;
    padding: var(--space-24);
    align-items: flex-start;
    flex-direction: column;
    background-color: var(--light-200);
    border-bottom: 1px solid var(--border-neutral);
    position: relative;

    h2 {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin: var(--space-0);
      gap: var(--space-8);
      color: var(--text-dark);
      font-size: var(--fs-24);
      margin-bottom: var(--space-8);
      font-weight: 600;
    }

    p {
      margin: var(--space-0);
      border-radius: 6px;
      font-size: var(--fs-14);
      color: var(--text-dark);

      &.plan-subtitle {
        font-weight: 600;
        margin-bottom: 5px;
      }

      &.plan-summary {
        color: var(--text-neutral);
      }

    }

  }

  .upgrade-box-price {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    padding: var(--space-24);

    h1 {
      margin-bottom: var(--space-12);
      font-size: var(--fs-48);

      span {
        color: var(--text-neutral);
      }
    }

    p {
      margin: var(--space-0);
    }

    .user {
      margin-bottom: var(--space-8);
      color: var(--text-neutral);
    }

    .total {
      color: var(--text-dark);
      font-size: var(--fs-14);
      line-height: 30px;

      span {
        border-bottom: 1px dashed var(--border-neutral-darker);
        padding-bottom: var(--space-4);
        font-weight: 600;
      }
    }

    .tag {
      margin-top: var(--space-32);
      display: flex;
      gap: var(--space-8);
    }

  }

  .upgrade-button {
    padding: var(--space-0) var(--space-24) var(--space-10);

    hr {
      width: 100%;
      height: 2px;
      border-top: 1px solid var(--border-neutral) !important;
      margin-top: 30px;
      margin-bottom: 0;
    }
  }

  .upgrade-package {
    padding: var(--space-0) var(--space-24) var(--space-24);

    ul {
      list-style-type: none;
      margin: var(--space-0);
      padding: var(--space-0);

      li {
        font-size: var(--fs-14);
        display: flex;
        margin-bottom: var(--space-16);
      }
    }

    .subheadline {
      font-size: var(--fs-13);
      color: var(--text-neutral);
      font-weight: 600;
      margin: var(--space-16) var(--space-0) var(--space-24);
    }

    .nested-list {
      width: 100%;

      &.one {
        min-height: 480px;
      }

      &.two {
        min-height: 240px;
      }
    }

    .in-pipeline {
      width: 100%;
      margin-bottom: var(--space-16);
      background: var(--item-blue-bg-hover);
      border: 1px solid var(--item-blue-border-hover);
      border-radius: $br-sm;
      padding: var(--space-16);
      min-height: 218px;

      .subheadline {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: normal;
        gap: var(--space-8);
        color: var(--text-blue);
        margin: var(--space-0) var(--space-0) var(--space-16);
      }

      li {
        &:last-child {
          margin-bottom: var(--space-0);
        }
      }
    }

    .icon {
      min-width: 16px;
      color: var(--text-dark);
      text-align: center;
      margin-right: var(--space-8);

      .soon {
        color: var(--text-neutral);
      }
    }

    .title {
      font-weight: 500;
      display: block;
      margin-bottom: var(--space-2);
    }

    .text {
      font-size: var(--fs-12);
      color: var(--text-neutral);
      display: inline-block;
      line-height: 20px;
    }

    .soon {
      color: var(--text-blue);
    }

    .jira {
      height: 15px;
      margin: var(--space-2);
      margin-top: var(--space-negative-2);
      display: inline;
    }

    .figma {
      height: 14px;
      margin: var(--space-2);
      margin-top: var(--space-negative-2);
      display: inline;
    }

  }
}

</style>
